<agpr-panel
    header="AMT.contentProviders"
    [paddingBottom]="0"
    [marginTop]="20"
>
    <div
        *ngIf="licenses"
        class="agpr-flex-container"
    >
        <div class="agpr-column">
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.MOREOVER}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.online"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.MOREOVER]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.SMART_PROXY}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.smart_proxy"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.SMART_PROXY]"
                (onChange)="handleLicenseChangeWithSublicenses()"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.ACQUIRE}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.acquire"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.ACQUIRE]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.BURELLES_LUCE}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.burrelles"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.BURELLES_LUCE]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.IPCB}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.ipcb"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.IPCB]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.FINANCIAL_TIMES}}_checkbox"
                class="agpr-providers-preferences-financial-times"
                [binary]="true"
                label="AMT.contentProviders.finacial_times"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.FINANCIAL_TIMES]"
                (onChange)="handleLicenseChange()"
            >
                @if (displayFinancialTimesPodcastUpsell) {
                    <span
                        class="fa-solid fa-circle-exclamation"
                        role="img"
                        [agprPopover]="financialTimesPopover"
                        [popoverText]="'AMT.contentProviders.finacial_times.info.bundle'"
                    ></span>
                }
            </agpr-checkbox>
        </div>
        <div class="agpr-column">
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.PRECISE}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.kantar"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.PRECISE]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.LEXISNEXIS}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.lexisNexis"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.LEXISNEXIS]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.MELTWATER}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.meltwater"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.MELTWATER]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.POST_MEDIA}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.post_media"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.POST_MEDIA]"
            ></agpr-checkbox>
            <agpr-checkbox
                [id]="'contentProvider_CS_Supplemental_checkbox'"
                [binary]="true"
                label="AMT.contentProviders.cs_supplemental"
                [disabled]="isReadOnly"
                [(ngModel)]="csSupplemental"
                (onChange)="handleCsSupplementalChange($event)"
            ></agpr-checkbox>

        </div>
        <div class="agpr-column">
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.XCAGO}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.pmg"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.XCAGO]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.CLA_ONLINE}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.cla_online"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.CLA_ONLINE]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.CLA_PRINT}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.cla_print"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.CLA_PRINT]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.NLA_ECLIPS}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.nla_online"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.NLA_ECLIPS]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProvider_{{LicensesEnum.NLA_PRINT}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.nla_print"
                [disabled]="isReadOnly"
                [(ngModel)]="licenses[LicensesEnum.NLA_PRINT]"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProviderSublicense_{{SublicensesEnum.REFMEDIA_ONLINE_PRINT}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.refMedia_online_print"
                [disabled]="isReadOnly"
                [(ngModel)]="sublicenses[SublicensesEnum.REFMEDIA_ONLINE_PRINT]"
                (onChange)="refMediaSublicenseChange()"
            ></agpr-checkbox>
            <agpr-checkbox
                id="contentProviderSublicense_{{SublicensesEnum.REFMEDIA_PARLIAMENTARY}}_checkbox"
                [binary]="true"
                label="AMT.contentProviders.refMedia_parliamentary"
                [disabled]="isReadOnly"
                [(ngModel)]="sublicenses[SublicensesEnum.REFMEDIA_PARLIAMENTARY]"
                (onChange)="refMediaSublicenseChange()"
            ></agpr-checkbox>
        </div>
    </div>
    <div *ngIf="licenses[LicensesEnum.BURELLES_LUCE]" class="agpr-burrelles-accounts">
        <agpr-multi-text-input
            label="AMT.contentProviders.burrelles.accounts"
            [disabled]="isReadOnly"
            placeholder="AMT.contentProviders.burrelles.placeholder"
            [(ngModel)]="burrellesAccountIds"
            (ngModelChange)="burrellesAccountIdsChange($event)"
        ></agpr-multi-text-input>
    </div>
    <div
        class="agpr-flex-container"
    >
    @if (licenses && licenses[LicensesEnum.SMART_PROXY]) {
        <div class="agpr-column">
            <div class="agpr-column-label">Online Supplemental Options</div>
            <agpr-checkbox
                id="contentProviderSublicense_{{SublicensesEnum.SMART_PROXY_ONLINE}}_checkbox"
                    [binary]="true"
                    label="AMT.contentProviders.smart_proxy_online"
                    [disabled]="isReadOnly"
                    [(ngModel)]="sublicenses[SublicensesEnum.SMART_PROXY_ONLINE]"
                ></agpr-checkbox>
                <agpr-checkbox
                    id="contentProviderSublicense_{{SublicensesEnum.SMART_PROXY_FRENCH_CANADIAN}}_checkbox"
                    [binary]="true"
                    label="AMT.contentProviders.smart_proxy_french_canadian"
                    [disabled]="isReadOnly"
                    [(ngModel)]="sublicenses[SublicensesEnum.SMART_PROXY_FRENCH_CANADIAN]"
                ></agpr-checkbox>
                <agpr-checkbox
                    id="contentProviderSublicense_{{SublicensesEnum.SMART_PROXY_LE_DEVOIR}}_checkbox"
                    [binary]="true"
                    label="AMT.contentProviders.smart_proxy_le_devoir"
                    [disabled]="isReadOnly"
                    [(ngModel)]="sublicenses[SublicensesEnum.SMART_PROXY_LE_DEVOIR]"
                ></agpr-checkbox>
                <agpr-checkbox
                    id="contentProviderSublicense_{{SublicensesEnum.SMART_PROXY_POST_MEDIA}}_checkbox"
                    [binary]="true"
                    label="AMT.contentProviders.smart_proxy_post_media"
                    [disabled]="isReadOnly"
                    [(ngModel)]="sublicenses[SublicensesEnum.SMART_PROXY_POST_MEDIA]"
                ></agpr-checkbox>
        </div>
    }
    </div>

</agpr-panel>


<ng-template #financialTimesPopover>
    <div class="agpr-providers-preferences-financial-times-popover">
        <span class="agpr-providers-preferences-financial-times-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
        <div class="agpr-providers-preferences-financial-times-popover-content">
            <p class="agpr-providers-preferences-financial-times-popover-content-message">
                {{ 'AMT.contentProviders.finacial_times.info.bundle' | localize }}
            </p>
        </div>
    </div>
</ng-template>
